/*
Copyright (c) 2012-2026 Grab Taxi Holdings PTE LTD (GRAB), All Rights Reserved.
NOTICE: All information contained herein is, and remains the property of GRAB.
The intellectual and technical concepts contained herein are confidential,
proprietary and controlled by GRAB and may be covered by patents, patents in process,
and are protected by trade secret or copyright law.

You are strictly forbidden to copy, download, store (in any medium), transmit, disseminate,
adapt or change this material in any way unless prior written permission is obtained from GRAB.
Access to the source code contained herein is hereby forbidden to anyone except current GRAB
employees or contractors with binding Confidentiality and Non-disclosure agreements explicitly
covering such access.

The copyright notice above does not evidence any actual or intended publication or disclosure of
this source code, which includes information that is confidential and/or proprietary,
and is a trade secret, of GRAB.

ANY REPRODUCTION, MODIFICATION, DISTRIBUTION, PUBLIC PERFORMANCE, OR PUBLIC DISPLAY OF OR
THROUGH USE OF THIS SOURCE CODE WITHOUT THE EXPRESS WRITTEN CONSENT OF GRAB IS STRICTLY PROHIBITED,
AND IN VIOLATION OF APPLICABLE LAWS AND INTERNATIONAL TREATIES. THE RECEIPT OR POSSESSION OF THIS
SOURCE CODE AND/OR RELATED INFORMATION DOES NOT CONVEY OR IMPLY ANY RIGHTS TO REPRODUCE,
DISCLOSE OR DISTRIBUTE ITS CONTENTS, OR TO MANUFACTURE, USE, OR SELL ANYTHING THAT IT MAY DESCRIBE,
IN WHOLE OR IN PART.
*/
import React from "react"
import {
  ErrorNotificationContent,
  GetErrorNotificationContent,
} from "queries/apiClient"

/** Mexcore seller-center error JSON in axios response `data`. */
type MexcoreErrorResponseBody = {
  message?: string
  error?: {
    msg?: string
    dev_message?: string
  }
}

const withTrailingPeriod = (text: string): string => {
  const t = text.trim()
  if (!t) return ""
  return t.endsWith(".") ? t : `${t}.`
}

/**
 * Seller-center error toast: generic title (`defaultMessage`); body is a React description
 * with the detail line and (when present) a `<br />` before `Trace ID: …`.
 */
export const getSellerCenterErrorNotificationContent: GetErrorNotificationContent = ({
  data,
  defaultMessage,
  trace,
}): ErrorNotificationContent => {
  let detail = ""
  if (data && typeof data === "object") {
    const body = data as MexcoreErrorResponseBody
    detail =
      body.error?.dev_message?.trim() ||
      body.message?.trim() ||
      body.error?.msg?.trim() ||
      ""
  }

  const firstLine = withTrailingPeriod(detail || defaultMessage)
  const description = trace ? (
    <>
      {firstLine}
      <br />
      Trace ID: {trace}
    </>
  ) : (
    firstLine
  )

  return {
    message: defaultMessage,
    description,
  }
}
